export default {
      id: "icon--profile-usage",
      viewBox: "0 0 22.3 22.3",
      url: __webpack_public_path__ + "redesign-sprite.svg#icon--profile-usage",
      toString: function () {
        return this.url;
      }
    }